import {createReducer, on} from "@ngrx/store";
import * as AccountAchievementActions from './account-achievements.actions';
import {AccountAchievement} from "../../models/AccountAchievement";
export const accountAchievementFeatureKey = 'accountAchievement';
export const accountAchievementInitialState: AccountAchievement[] = null;
export const AccountAchievementsReducer = createReducer<AccountAchievement[] | null>(
  accountAchievementInitialState,
  on(AccountAchievementActions.update, (_state, { accountAchievement }) => accountAchievement),
);
